import { createFileRoute } from '@tanstack/react-router';

import { SignupFormEditorView } from '@/components/signup-forms/SignupFormEditorView';
import { useSyncTenantFromParams } from '@/context/organization-context';

// `seed` carries the prompt typed in the "create from scratch" dialog so the
// editor can auto-run the first design turn on open. It's cleared from the URL
// once consumed.
export const Route = createFileRoute('/_authed/dashboard_/o/$orgId/c/$clientId/signup-forms/$formId')({
  validateSearch: (search: Record<string, unknown>): { seed?: string } => ({
    seed: typeof search.seed === 'string' ? search.seed : undefined,
  }),
  component: RouteComponent,
});

function RouteComponent() {
  const { formId, orgId, clientId } = Route.useParams();
  useSyncTenantFromParams(orgId, clientId);
  const { seed } = Route.useSearch();
  return <SignupFormEditorView formId={formId} initialPrompt={seed} />;
}
